import { GOOGLE_MAP_API_KEY } from '@constants/common';
import { useJsApiLoader } from '@react-google-maps/api';

export const useMap = () => {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAP_API_KEY,
    });

    return { isLoaded, loadError };
};
